/* ============================================================
   Shared enquiry form handler (visa pages, visa consulting).

   Any <form data-enquiry> is posted to /send-mail.php as JSON:
     data-form-type="visa"     -> formType
     data-country="France"     -> country
     name="plan"               -> visa type; falls back to the active
                                  .vp-tab label on visa-details pages
     name="website"            -> honeypot, must stay empty
   On success the visitor goes to /thank-you.html with the
   reference number send-mail.php returns.
   ============================================================ */
(function () {
  'use strict';

  var PHONE_RE = /^([6-9]\d{9}|\+\d{8,15})$/;   // same rule as send-mail.php
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  var FALLBACK = 'Could not send right now. Please call +91 98208 50904 or WhatsApp us.';

  function normalisePhone(v) {
    return v.replace(/[\s\-().]/g, '');
  }

  /** Fill <select data-travel-months> with the next 12 months. */
  function fillTravelMonths(select) {
    var d = new Date();
    d.setDate(1);
    for (var i = 0; i < 12; i++) {
      var label = d.toLocaleString('en-IN', { month: 'short', year: 'numeric' });
      var opt = document.createElement('option');
      opt.value = label;
      opt.textContent = label;
      select.appendChild(opt);
      d.setMonth(d.getMonth() + 1);
    }
  }

  function showMessage(form, text, isError) {
    var box = form.querySelector('.vp-form-msg');
    if (!box) return;
    box.textContent = text;
    box.classList.toggle('is-error', !!isError);
  }

  function currentPlan(form) {
    var field = form.querySelector('[name="plan"]');
    if (field && field.value) return field.value;
    var tab = document.querySelector('#vpTabs .vp-tab.active');
    return tab ? tab.textContent.trim() : '';
  }

  function validate(form) {
    var name = form.elements.fullName.value.trim();
    var phone = normalisePhone(form.elements.phone.value.trim());
    var email = form.elements.email.value.trim();
    if (name.length < 3) return { field: 'fullName', msg: 'Please enter your full name.' };
    if (!PHONE_RE.test(phone)) return { field: 'phone', msg: 'Please enter a valid mobile number: 10 digits, or + and country code.' };
    if (!EMAIL_RE.test(email)) return { field: 'email', msg: 'Please enter a valid email address.' };
    return null;
  }

  function onSubmit(e) {
    e.preventDefault();
    var form = e.currentTarget;
    var button = form.querySelector('[type="submit"]');
    if (button.disabled) return; // already sending

    var problem = validate(form);
    if (problem) {
      showMessage(form, problem.msg, true);
      form.elements[problem.field].focus();
      return;
    }

    var get = function (name) {
      var el = form.elements[name];
      return el ? el.value.trim() : '';
    };
    var payload = {
      formType: form.dataset.formType || 'visa',
      fullName: get('fullName'),
      phone: normalisePhone(get('phone')),
      email: get('email'),
      message: get('message'),
      country: form.dataset.country || get('country'),
      plan: currentPlan(form),
      travelDate: get('travelDate'),
      website: get('website'),
      sourcePage: window.location.pathname
    };

    var label = button.textContent;
    button.disabled = true;
    button.textContent = 'Sending…';
    showMessage(form, '', false);

    fetch('/send-mail.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res && res.success) {
          window.location.href = '/thank-you.html?ref=' + encodeURIComponent(res.ref || '') +
            '&type=' + encodeURIComponent(payload.formType);
          return;
        }
        showMessage(form, (res && res.message) || FALLBACK, true);
        button.disabled = false;
        button.textContent = label;
      })
      .catch(function () {
        showMessage(form, FALLBACK, true);
        button.disabled = false;
        button.textContent = label;
      });
  }

  function init() {
    document.querySelectorAll('form[data-enquiry]').forEach(function (form) {
      form.querySelectorAll('select[data-travel-months]').forEach(fillTravelMonths);
      var phone = form.elements.phone;
      if (phone) {
        phone.addEventListener('input', function () {
          this.value = this.value.replace(/[^\d+\s\-]/g, '').slice(0, 20);
        });
      }
      form.addEventListener('submit', onSubmit);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
